import '@fontsource/poppins';
import axios from 'axios';

import { TextField } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';

import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { ViewButton } from '@src/components/buttons';
import { useAuth } from '@src/contexts/authContext';

const url = `${process.env.REACT_APP_API_URL}`;

export default function TableNurseDeleted() {
  const navigate = useNavigate();
  const format_date = { year: 'numeric', month: 'short', day: 'numeric' };
  const handleClickDetail = (userId) => {
    navigate(`/verified-nurse-detail/${userId}`);
  };

  const [loading, setLoading] = useState();

  const [list, setList] = useState([]);
  const { auth } = useAuth();

  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredList = list
    ?.filter((row) => {
      const lowerCaseSearchQuery = searchQuery.toLowerCase();
      return (
        (row &&
          row.full_name &&
          row.full_name.toLowerCase().includes(lowerCaseSearchQuery)) ||
        (row?.email &&
          row.email.toLowerCase().includes(lowerCaseSearchQuery)) ||
        (row?.phone_number &&
          row.phone_number.toLowerCase().includes(lowerCaseSearchQuery))
      );
    })
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [status, setStatus] = useState('deleted');

  useEffect(() => {
    if (auth?.idToken) {
      setLoading(true);
      axios
        .get(`${url}/admin/users?role=nurse&status=${status}`, {
          headers: {
            Authorization: `Bearer ${auth?.idToken}`,
          },
        })
        .then((response) => {
          setList(response.data);
          setLoading(false);
        })
        .catch((error) => {
          console.log('Error', error.message);
          setLoading(false);
        });
    }
  }, [auth, status]);
  return (
    <div>
      <Box sx={{ width: '100%' }} className='flex w-full justify-end py-4'>
        <TextField
          fullWidth
          size='medium'
          variant='outlined'
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: 'white',
              height: '50px',
            },
            mt: '5px',
            width: '300px',
          }}
          onChange={handleSearch}
          placeholder='Search by name, email or phone'
        />
      </Box>
      {loading ? (
        <div className='font-poppins py-6 px-8 text-gray-500'>Loading...</div>
      ) : (
        <span className='flex w-full flex-col items-start py-3'>
          <TableContainer
            className='rounded-xl'
            component={Paper}
            style={{
              width: '100%',
              paddingBottom: '12px',
              paddingLeft: '12px',
              paddingRight: '12px',
            }}
          >
            <Table sx={{ minWidth: 650 }} aria-label='simple table'>
              <TableHead>
                <TableRow>
                  <TableCell
                    className='text-xs font-bold text-gray-400'
                    // style={{ width: '220px' }}
                  >
                    Name
                  </TableCell>
                  <TableCell
                    className='text-xs font-bold text-gray-400'
                    style={{ padding: 0 }}
                  >
                    Phone Number
                  </TableCell>
                  <TableCell
                    className='text-xs font-bold text-gray-400'
                    style={{ padding: 0 }}
                  >
                    Email
                  </TableCell>
                  <TableCell
                    className='text-xs font-bold text-gray-400'
                    style={{ padding: 0, width: '150px' }}
                  >
                    Registered Date
                  </TableCell>
                  <TableCell
                    className='text-xs font-bold text-gray-400'
                    style={{ padding: 4, width: '170px' }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(filteredList) && filteredList.length > 0 ? (
                  filteredList
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow
                        hover
                        role='checkbox'
                        tabIndex={-1}
                        key={row._id}
                        sx={{
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell
                          component='th'
                          scope='row'
                          className='border-white text-sm font-bold text-gray-500'
                        >
                          <span
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '12px',
                            }}
                          >
                            <Avatar alt='' src={`${url}${row?.profile_pict}`} />
                            <span
                              style={{
                                display: 'inline-block',
                                maxWidth: 200,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                verticalAlign: 'bottom',
                              }}
                              title={row?.full_name || 'No name added'}
                            >
                              {row?.full_name || 'No name added'}
                            </span>
                          </span>
                        </TableCell>
                        <TableCell
                          className='border-white text-sm font-bold text-gray-500'
                          style={{ padding: 0 }}
                        >
                          {row?.phone_number}
                        </TableCell>
                        <TableCell
                          className='border-white text-sm font-bold text-gray-500'
                          style={{
                            padding: 0,
                            maxWidth: 200,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                          }}
                          title={row?.email}
                        >
                          {row?.email}
                        </TableCell>
                        <TableCell
                          className='border-white text-sm font-bold text-gray-500'
                          style={{ padding: 0 }}
                        >
                          {/* {row?.createdAt
                          ? `${new Date(row?.createdAt).toLocaleDateString(
                              'au-AU',
                              format_date,
                            )} | ${formatTime(row?.createdAt)}`
                          : 'No date and time added'} */}

                          {row?.createdAt
                            ? `${new Date(row?.createdAt).toLocaleDateString(
                                'au-AU',
                                format_date,
                              )}`
                            : 'No date added'}
                        </TableCell>
                        <TableCell
                          className='border-white text-sm font-bold text-gray-500'
                          style={{ padding: 0 }}
                        >
                          <ViewButton
                            onClick={() => handleClickDetail(row?._id)}
                          />
                          &nbsp; &nbsp;
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell
                      className='border border-white'
                      colSpan={6}
                      align='center'
                    >
                      <div className='font-poppins py-6 text-gray-500'>
                        No nurses listed
                      </div>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <Box
              className='flex justify-end py-3'
              sx={{ width: '100%', fontFamily: 'Poppins' }}
            >
              <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component='div'
                count={list.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Box>
          </TableContainer>
        </span>
      )}
    </div>
  );
}
